<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="860px" scrollable>
    <v-card>
      <v-card-title class="text-subtitle-1">
        <v-icon small class="mr-2">mdi-code-json</v-icon>
        Conversación (JSON para IA)
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <pre class="json-conversacion-ia">{{ jsonStr }}</pre>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn small color="primary" depressed @click="$emit('copiar')">
          <v-icon small left>mdi-content-copy</v-icon>
          Copiar
        </v-btn>
        <v-btn small text @click="$emit('descargar')">
          <v-icon small left>mdi-download</v-icon>
          Descargar
        </v-btn>
        <v-spacer />
        <v-btn small text @click="$emit('input', false)">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogJsonConversacionIA',
  props: {
    value: { type: Boolean, default: false },
    jsonStr: { type: String, default: '' },
  },
}
</script>

<style scoped>
.json-conversacion-ia {
  margin: 0;
  padding: 16px;
  max-height: 60vh;
  overflow: auto;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
  background: #f5f5f5;
}
</style>
